import React, { useLayoutEffect, useRef, useState } from "react";

const FitText = ({ children, maxFontSize = 22, minFontSize = 8 }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [fontSize, setFontSize] = useState(maxFontSize);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const text = textRef.current;
    if (!container || !text) return;

    // Reset to max first
    text.style.fontSize = `${maxFontSize}px`;
    let size = maxFontSize;

    // Use parent's width as the constraint
    const parentWidth = container.parentElement?.offsetWidth || container.offsetWidth;

    while (text.scrollWidth > parentWidth && size > minFontSize) {
      size -= 0.5;
      text.style.fontSize = `${size}px`;
    }

    setFontSize(size);
  }, [children, maxFontSize, minFontSize]);

  return (
    <div ref={containerRef} style={{ width: "100%", overflow: "hidden", display: "flex", justifyContent: "center" }}>
      <h2
        ref={textRef}
        style={{
          fontSize: `${fontSize}px`,
          whiteSpace: "nowrap",
          lineHeight: 1.2,
          textAlign: "center",
          margin: 0,
          display: "inline-block",
        }}
      >
        {children}
      </h2>
    </div>
  );
};

export default FitText;